import { render, staticRenderFns } from "./userStamps.vue?vue&type=template&id=1b969621"
import script from "./userStamps.vue?vue&type=script&lang=js"
export * from "./userStamps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports